/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/extrude 层；
 * 2. 负责封装拉伸凸台特征的语义子类；
 * 3. 公共骨架由拉伸族原型基类统一维护，本类只保留凸台语义标签。
 *
 * 文件职责：
 * 1. 作为拉伸凸台在 prototype 层的专属语义入口；
 * 2. 让上层可在不判断原始命令参数的前提下识别“凸台拉伸”；
 * 3. 公共构造逻辑全部复用拉伸族基类，避免重复实现。
 */

import type { FeatureReferenceBinding } from '../../binding/FeatureReferenceBinding';
import { ExtrudeFeatureDefinitionModel } from '../../definition/extrude/ExtrudeFeatureDefinition';
import { ExtrudeFeaturePrototype } from './ExtrudeFeaturePrototype';

/**
 * 拉伸凸台特征原型。
 */
export class BossExtrudeFeaturePrototype extends ExtrudeFeaturePrototype {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        featureId: string;
        definition: ExtrudeFeatureDefinitionModel;
        bindings: FeatureReferenceBinding[];
        sourceSketchId?: string | null;
    }) {
        super(input);
    }
}
